import { useDimensions } from "@chakra-ui/hooks"
import { RefObject, useState } from "react"
import useIsomorphicLayoutEffect from "./useIsomorphicLayoutEffect"

export const useIsOverflow = (ref: RefObject<HTMLElement>) => {
  const [isOverflow, setIsOverflow] = useState<boolean>(false)
  const dimensions = useDimensions(ref, true)

  useIsomorphicLayoutEffect(() => {
    const { current } = ref

    if (current) {
      const hasOverflow = current.scrollWidth > current.offsetWidth || current.scrollHeight > current.offsetHeight
      setIsOverflow(hasOverflow)
    }
  }, [ref, dimensions])

  return isOverflow
}
